export default "__VITE_ASSET__CsyVJYWP__"